import { z } from "zod";

import type { AdministrativeAreaOption } from "@/components/AdministrativeAreaTreeSelect";

import type { OptionValue, SelectOption } from "./types";

const hasRequiredOptionValue = (value: unknown): value is { value: OptionValue } => {
  if (!value || typeof value !== "object" || !("value" in value)) {
    return false;
  }

  const optionValue = (value as { value?: unknown }).value;

  if (typeof optionValue === "number") {
    return true;
  }

  return typeof optionValue === "string" && optionValue.trim().length > 0;
};

const requiredString = (message: string) =>
  z.preprocess(
    value => (value === undefined || value === null ? "" : value),
    z.string().refine(value => value.trim().length > 0, { message })
  );

const requiredSelectOption = (message: string) =>
  z.custom<SelectOption>(hasRequiredOptionValue, { message });

const requiredAdministrativeArea = (message: string) =>
  z.custom<AdministrativeAreaOption>(hasRequiredOptionValue, { message });

export const createTraderDetailsStepOneSchema = (requiredMessage: string) =>
  z.looseObject({
    name: requiredString(requiredMessage),
    trader_type: requiredSelectOption(requiredMessage),
    language: requiredSelectOption(requiredMessage),
    location: requiredAdministrativeArea(requiredMessage),
    physical_address: z.string().nullable().optional(),
    is_wfp_vendor: z.boolean().nullable().optional().default(false),
    wings_id: z.string().nullable().optional(),
    eligible_aggregators: z.array(z.custom<SelectOption>()).nullable().optional(),
  });
